module.exports = __webpack_public_path__ + "img/go2.a486a323.png";